import { type HansardSection } from '@prisma/client'
import { getSubtitle } from '#app/models.client/sections/index.ts'
import DateDisplay from './DateDisplay'

export default function SectionHeader({
  section,
}: {
  section: HansardSection
}) {
  return (
    <div className="">
      <div className="mb-4 mt-6 flex">
        <DateDisplay day={section.day} />
        <div>
          <h1 className="ml-4 self-center pt-6 text-3xl font-bold">
            {section.title}
          </h1>
          <div className="mb-2 ml-4 flex">
            <div className="text-sm text-gray-600">{getSubtitle(section)}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
